export const updateArrayOrder = (array, fromIndex, toIndex) => {
  if (!Array.isArray(array)) return [];
  if (
    fromIndex < 0 ||
    fromIndex >= array.length ||
    toIndex < 0 ||
    toIndex >= array.length ||
    fromIndex === toIndex
  ) {
    return [...array];
  }
  const copy = [...array];
  const [element] = copy.splice(fromIndex, 1);
  copy.splice(toIndex, 0, element);
  return copy;
};

export const duplicateStickyStep = (backgroundImages = [], containers = [], i) => {
  const bgCopy = [...backgroundImages];
  const contCopy = [...containers];

  const sourceBg = bgCopy[i];
  const clonedBg = sourceBg ? JSON.parse(JSON.stringify(sourceBg)) : undefined;

  const sourceContainer = contCopy[i];
  const clonedContainer = sourceContainer
    ? JSON.parse(JSON.stringify(sourceContainer))
    : {
        startColumn: 5,
        endColumn: 6,
        horizontalAlign: "center",
        stepPosition: "bottom",
        backgroundColor: "#ffffffb3",
        borderRadius: true,
        blocks: [{ type: "text", placeholder: "Klikk her for å skrive" }],
      };

  bgCopy.splice(i + 1, 0, clonedBg);
  contCopy.splice(i + 1, 0, clonedContainer);

  return {
    backgroundImage: bgCopy,
    containers: contCopy,
  };
};

export const addStickyStep = (backgroundImages = [], containers = []) => {
  const newContainer = {
    startColumn: 5,
    endColumn: 6,
    horizontalAlign: "center",
    stepPosition: "bottom",
    backgroundColor: "#ffffffb3",
    borderRadius: true,
    blocks: [
      {
        type: "text",
        placeholder: "Klikk her for å skrive",
      },
    ],
  };

  return {
    backgroundImage: [...backgroundImages, undefined],
    containers: [...containers, newContainer],
  };
};

export const deleteStickyStep = (backgroundImages = [], containers = [], i) => {
  return {
    backgroundImage: backgroundImages.filter((_, index) => index !== i),
    containers: containers.filter((_, index) => index !== i),
  };
};

export const normalizeMultiBackgrounds = (section) => {
  const containers = section?.containers || [];
  const rawBg = Array.isArray(section?.backgroundImage)
    ? section.backgroundImage
    : [];

  return containers.map((_, i) => (rawBg[i] ? rawBg[i] : undefined));
};
